// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zcp-hex-input{width:66px;height:24px;font-size:12px}", ""]);
// Exports
module.exports = exports;
